module.exports = __webpack_public_path__ + "static/img/20220507_04.35e760c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/2022/20220507_04.png
// module id = cXVY
// module chunks = 0